import React from 'react';
import style from '../orderItemDetail.module.scss';
import cn from 'classnames';
import warningImage from '@assets/images/disclaimer.svg';

const DisclaimerBanner = React.memo(({ text }) => (
  <div className={cn(style.disclaimerMessage, 'fs_12 mt-2  mx-0 rounded')}>
    <div className="row col-12 mx-0 py-2 px-0 align-items-center justify-content-center">
      <img src={warningImage} alt="" />
      <div className="col-11 text-break pr-2 py-1">{text}</div>
    </div>
  </div>
));

export default DisclaimerBanner;
